import React, {useState, useEffect, Fragment} from 'react'
import {FormGroup, Label, Input} from 'reactstrap'
import { Block } from '../../styles/commons'
import Button from '../Button/Button'
import Portal from '../../stacks/portal/PortalAWS'
import {useErrorToast} from '../../hooks/useErrorToast';
import MessageList from './MessageList'
import RefreshData from '../RefreshData/RefreshData'

const MessageCenter = props => {
  const {setErrorMsg, errorToast} = useErrorToast('');
  const [messages, setMessages] = useState([])
  const [companyName, setCompanyName] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(true)

  const {destinationId} = props;

  async function sendMessage() {
    try {
      const api = Portal.getInstance()
      setLoading(true)
      if (props.sof) {
        await api.sendMessageAsSOF(destinationId, message)
      } else {
        await api.sendMessage(destinationId, message)
      }
      setMessage('')
      await getMessages(destinationId)
      setLoading(false)
    }
    catch (err) {
      console.error(`sendMessage ${err.status} ${err.message} ${err.stack}`)
      setErrorMsg(err.message)
      setLoading(false)
    }
  }

  async function getMessages(destinationId) {
    try {
      const api = Portal.getInstance()
      setLoading(true)
      if (props.sof) {
        const mess = await api.retrieveMessagesAsSOF(destinationId)
        setMessages(mess.messages)
        setCompanyName(mess.companyName)
      } else {
        const mess = await api.retrieveMessages(destinationId)
        setMessages(mess.messages)
        setCompanyName(mess.companyName)
      }
      setLoading(false)
    }
    catch (err) {
      console.error(`getMessages ${err.status} ${err.message} ${err.stack}`)
      setErrorMsg(err.message)
      setLoading(false)
    }
  }

  useEffect(() => {
    getMessages(destinationId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function refresh() {
    getMessages(destinationId)
  }
  
  return (
    <Fragment>
      <h1>{companyName}</h1>
      <Block>
        <RefreshData style={{textAlign: 'right'}} loading={loading} onClick={refresh}/>
        <FormGroup>
          <Label for='message'>Send message</Label>
          <Input id='message' type='text' value={message} onChange={(e) => {setMessage(e.target.value)}}/>
        </FormGroup>

        <Button disabled={message.trim() === ''} click={sendMessage}>Send</Button>
        <p/>
        <MessageList {...props} messages={messages}/>
      </Block>
      {errorToast}
    </Fragment>
  )
}

export default MessageCenter